module.exports = __webpack_public_path__ + "static/media/trailer_navy.7501ae86.svg";